module.exports = __webpack_public_path__ + "static/media/close.a61a7677.svg";